import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArticleView } from "@/components/ArticleView";
import { statusLabel } from "@/lib/content";
import { ArrowLeft, Pencil } from "lucide-react";

export default function ArticlePreview() {
  const { id } = useParams();
  const [article, setArticle] = useState(undefined);

  useEffect(() => {
    api.get(`/admin/articles/${id}`).then(({ data }) => setArticle(data)).catch(() => setArticle(null));
  }, [id]);

  if (article === undefined) return <p className="text-bz-slate">Chargement…</p>;
  if (article === null) return <p className="text-bz-slate">Article introuvable.</p>;

  return (
    <div data-testid="admin-article-preview">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <Link to="/admin/articles" className="inline-flex items-center gap-2 text-sm text-bz-slate hover:text-bz-navy">
          <ArrowLeft size={16} strokeWidth={1.5} /> Retour à la liste
        </Link>
        <div className="flex items-center gap-4">
          <span className="text-xs uppercase tracking-[0.12em] text-bz-slate">Prévisualisation · {statusLabel(article.status)}</span>
          <Link to={`/admin/articles/${id}/edit`} className="inline-flex items-center gap-2 border border-bz-navy px-4 py-2 text-xs uppercase tracking-[0.12em] text-bz-navy transition-colors hover:bg-bz-navy hover:text-bz-ivory">
            <Pencil size={14} strokeWidth={1.6} /> Modifier
          </Link>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-3xl border border-bz-line bg-white p-8 lg:p-12">
        <ArticleView article={article} />
      </div>
    </div>
  );
}
